/* eslint-disable */
import { useEffect, useState } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  DialogActions,
  useTheme,
} from '@mui/material';

import api from '../../services/api';
import toastError from '../../toasts/toastError';
import { i18n } from '../../translate/i18n';
import { getStyled } from './styles';

const DeleteMessageConfirmationModal = ({
  open,
  onClose,
  message,
  handleClose,
}) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
    handleClose();
    onClose(!open);
  };

  const handleCloseModal = () => {
    handleClose();
    onClose(!open);
  };

  return (
    <Dialog open={open} onClose={handleCloseModal} maxWidth='sm'>
      <DialogTitle sx={theme.custom.dialogColor}>Apagar Mensagem?</DialogTitle>

      <DialogContent dividers sx={theme.custom.dialogColor}>
        <Typography variant='subtitle1' gutterBottom>
          Deseja realmente apagar essa mensagem? <br />
          Esta ação não pode ser revertida.
        </Typography>
      </DialogContent>

      <DialogActions sx={theme.custom.dialogColor}>
        <Button
          onClick={handleCloseModal}
          variant='outlined'
          sx={theme.custom.cancelButton}
        >
          {i18n.t('messageOptionsMenu.confirmationModal.cancel')}
        </Button>
        <Button
          onClick={handleDeleteMessage}
          variant='outlined'
          sx={theme.custom.confirmButton}
        >
          {i18n.t('messageOptionsMenu.confirmationModal.okConfirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteMessageConfirmationModal;
